import logo from './logo.svg';
import './App.css';
import Navigation from './Layout/Navigation';
import Footer from './Layout/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
    <Navigation/>
    <Footer/>
    </>
  );
}

export default App;
